// @flow
import type { RotateInteractionDefinition, Point } from '../types'

type RotateOutput = {
  status: string,
}

export function rotate(
  definition: RotateInteractionDefinition,
  absolutePoint: Point,
): RotateOutput | boolean {
  if (definition.hitDetection(absolutePoint))
    return {
      status: 'rotation',
    }

  return false
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/rotate.js